<template>    
    <div class="card">
        <div class="card-header p-0 border-bottom-0">
            <ul class="nav nav-tabs" id="custom-tabs-five-tab" role="tablist">
                <li class="nav-item">
                    <a 
                        :class="tab == 'precios' ? 'nav-link active' : 'nav-link'" 
                        href="#"
                        @click.prevent="tab = 'precios'"
                    >
                        Configurar precios
                    </a>
                </li>
                <li class="nav-item">
                    <a 
                        :class="tab == 'descuentos' ? 'nav-link active' : 'nav-link'" 
                        href="#"
                        @click.prevent="tab = 'descuentos'"
                    >
                        Configurar cupones de descuento
                    </a>
                </li>
                <li class="nav-item">
                    <a
                        :class="tab == 'reservas' ? 'nav-link active' : 'nav-link'"
                        href="#"
                        @click.prevent="tab = 'reservas'"
                    >
                        Reservas
                    </a>
                </li>
                <li
                    v-if="permisos && permisos['eventos.editar']"
                    class="nav-item"
                >
                    <a
                        :class="tab == 'stockCompartido' ? 'nav-link active' : 'nav-link'"
                        href="#"
                        data-cy="sesion-sinrecinto-tab-stock-compartido"
                        @click.prevent="tab = 'stockCompartido'"
                    >
                        Stock compartido
                    </a>
                </li>
            </ul>
        </div>
        <div class="card-body">
            <div class="tab-content">
                <div class="tab-pane fade active show">
                    <transition name="fade" mode="out-in">
                        <div key="1" class="overlay-wrapper" v-if="tab == 'precios'">
                            <Precios :evento_id="evento_id" :sesion_id="sesion_id"/>
                        </div>
                        <div key="2" class="overlay-wrapper" v-if="tab == 'descuentos'">
                            <Vouchers :event_id="evento_id" :session_id="sesion_id"/>
                        </div>
                        <div key="3" class="overlay-wrapper" v-if="tab == 'reservas'">
                            <ReservasGenericas :evento_id="evento_id" :sesion_id="sesion_id" />
                        </div>
                        <div
                            key="4"
                            class="overlay-wrapper"
                            v-if="tab == 'stockCompartido' && permisos && permisos['eventos.editar']"
                        >
                            <StockCompartido
                                :evento-id="evento_id"
                                :sesion-id="sesion_id"
                                :enabled="permisos && !!permisos['eventos.editar']"
                            />
                        </div>
                    </transition>
                </div>                        
            </div>
        </div>
    </div>                
</template>

<script>
    import Precios from './Precios';
    import Vouchers from './Vouchers';
    import ReservasGenericas from '@/modules/admin/events/sesiones/views/ReservasGenericas.vue';
    import StockCompartido from '@/modules/admin/events/sesiones/views/StockCompartido.vue';

    export default {
        props: ['evento_id', 'sesion_id'],
        data() {
            return {
                tab: 'precios'
            }
        },
        computed: {
            permisos() {
                return this.$store.getters.getPermisos || {};
            }
        },
        components: {
            Precios, Vouchers, ReservasGenericas, StockCompartido
        }
    }
</script>
